module.exports = __webpack_public_path__ + "img/logory_new.2ebcbb4d.jpg";